import { jsPDF } from "jspdf";
import QRCode from "qrcode";


function formatDate(dateStr) {
  if (!dateStr) return "";

  const [year, month, day] = dateStr.split("-");

  const meses = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];

  return `${parseInt(day)} de ${meses[parseInt(month) - 1]} de ${year}`;
}

async function loadImageAsBase64(url) {
  const blob = await fetch(url).then(r => r.blob());
  return await new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}



export async function generateCertificatePDF({
  certificate,
  client,
  address,
  equipment,
  companyProfile
}) {
  const doc = new jsPDF("portrait", "mm", "letter");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 18;
  const rightColumnX = 112;
  const columnWidth = 78;

  const product = equipment.producto || {};
  const specs = equipment.specifications || {};

  console.log("=== DEBUG PRODUCTO ===");
console.log("PRODUCTO COMPLETO JSON:", JSON.stringify(product, null, 2));
console.log("IMAGEN PRODUCTO:", product.imagen);
console.log("LOGO MARCA:", product.brand_logo_url);


  let y = 22;


/* =========================
   HEADER LIMPIO
========================= */

// 🔹 Logo marca centrado arriba
let logoBottomY = 10;

if (product.brand_logo_url) {
  const brandLogo = await loadImageAsBase64(product.brand_logo_url);
  const props = doc.getImageProperties(brandLogo);

  const width = 35;
  const height = width * (props.height / props.width);

  const x = (pageWidth - width) / 2;
  const logoTopY = 10;

  doc.addImage(brandLogo, "PNG", x, logoTopY, width, height);
  logoBottomY = logoTopY + height;
}

// 🔹 El contenido arranca debajo del logo
y = logoBottomY + 15;
/* =========================
   TÍTULO + QR MISMA ALTURA
========================= */

doc.setFontSize(18);
doc.setFont("helvetica", "bold");
doc.setTextColor(90);

const titulo = `CERTIFICADO DE CONFORMIDAD No. ${certificate.folio}`;

// 🔹 Área izquierda (reserva espacio QR)
const titleMaxWidth = pageWidth - margin - 50;

const tituloLines = doc.splitTextToSize(
  titulo,
  titleMaxWidth
);

doc.text(tituloLines, margin, y);

// 🔹 QR alineado con el título
const qrData = await QRCode.toDataURL(
  `https://certificados.distribuidoradeoccidente.com/verify/${certificate.token}`
);

const qrSize = 24;

// 🔹 Alineado con el logo
const qrX = pageWidth - margin - qrSize;
const qrY = 10; // misma altura que logoTopY


doc.setDrawColor(180);
doc.roundedRect(qrX - 2, qrY - 2, qrSize + 4, qrSize + 4, 3, 3);
doc.addImage(qrData, "PNG", qrX, qrY, qrSize, qrSize);

doc.setFontSize(8);
doc.setFont("helvetica", "normal");
doc.setTextColor(90);

doc.text(
  "Validación digital",
  qrX + qrSize / 2,
  qrY + qrSize + 6,
  { align: "center" }
);

doc.setTextColor(0);


// 🔹 Ciudad + Fecha en una sola línea
doc.setFontSize(9);
doc.setFont("helvetica", "normal");

const ciudadFecha = `${companyProfile?.direccion?.ciudad}, ${companyProfile?.direccion?.estado}, México, a ${formatDate(certificate.issue_date)}`;

doc.setFontSize(9);
doc.setFont("helvetica", "normal");

doc.text(
  ciudadFecha,
  pageWidth - margin,
  qrY + qrSize + 10,
  { align: "right" }
);


doc.setTextColor(0);

y += tituloLines.length * 8 + 4;
  /* =========================
     DECLARACIÓN
  ========================= */

  doc.setDrawColor(20, 20, 80);
  doc.roundedRect(margin, y, pageWidth - margin * 2, 12, 4, 4);

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Declaración de conformidad", margin + 4, y + 8);

  y += 18;

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");

/* =========================================================
   Usamos primero el texto congelado del certificado.
   Así un certificado viejo no cambia si posteriormente
   modificamos el equipo certificable.
========================================================= */
const conformityText =
  certificate?.conformity_text_snapshot ||
  equipment?.conformity_text ||
  "";

const declaration = doc.splitTextToSize(
  conformityText,
  pageWidth - margin * 2
);
 doc.text(declaration, margin, y, {
  maxWidth: pageWidth - margin * 2,
  align: "justify"
});

  y += declaration.length * 4 + 6;

  /* =========================
     ESPECIFICACIONES
  ========================= */

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Especificaciones", margin, y);
  doc.text("Imagen", rightColumnX + columnWidth / 2, y, {
    align: "center"
  });

  y += 6;

  doc.setFontSize(8);

  let specsY = y;

  Object.values(specs).forEach(item => {
    if (!item?.label || !item?.value) return;

    doc.setFont("helvetica", "bold");
    doc.text(`${item.label}:`, margin, specsY);
    specsY += 3.5;

    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(item.value, columnWidth);
    doc.text(lines, margin, specsY);
    specsY += lines.length * 3.5 + 2;
  });


doc.setDrawColor(220);
doc.line(rightColumnX - 8, y - 4, rightColumnX - 8, specsY + 4);
/* =========================
   IMAGEN PRODUCTO
========================= */

let imageBottom = y;

if (product.imagen) {
  const img = await loadImageAsBase64(product.imagen);
  const props = doc.getImageProperties(img);

  // 🔥 ALTURA DINÁMICA basada en especificaciones
  const specsHeight = specsY - y;

  // dejamos un pequeño margen inferior
  const targetHeight = specsHeight - 5;

  let height = targetHeight;
  let width = height * (props.width / props.height);

  // 🔒 Protección por si la imagen se vuelve demasiado ancha
  if (width > columnWidth) {
    width = columnWidth;
    height = width * (props.height / props.width);
  }

  const x = rightColumnX + (columnWidth - width) / 2;

  doc.addImage(img, undefined, x, y, width, height);

  imageBottom = y + height;
}
  const contentBottom = Math.max(specsY, imageBottom) + 8;



  /* =========================
     ALCANCE
  ========================= */

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Alcance y limitaciones", margin, contentBottom);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);

  const leftColumnWidth = rightColumnX - margin - 10;


/* =========================================================
   Igual que conformidad: primero usamos el snapshot
   guardado al emitir el certificado.
========================================================= */
const scopeText =
  certificate?.scope_text_snapshot ||
  equipment?.scope_text ||
  "";

const scope = doc.splitTextToSize(
  scopeText,
  leftColumnWidth
);

  doc.text(scope, margin, contentBottom + 6, {
  maxWidth: leftColumnWidth,
  align: "justify"
});
/* =========================
   SELLO ESTAMPADO REAL
========================= */

if (companyProfile?.official_stamp_url) {
  const stamp = await loadImageAsBase64(
    companyProfile.official_stamp_url
  );

  const stampSize = 30; // más grande

  // Posición centrada en el bloque izquierdo
  const stampX = margin + 60;
  const stampY = contentBottom + 35;

  // Opacidad tipo tinta
  const gState = doc.GState ? new doc.GState({ opacity: 0.85 }) : null;
  if (gState) doc.setGState(gState);

  doc.addImage(
    stamp,
    undefined,
    stampX,
    stampY,
    stampSize,
    stampSize,
    undefined,
    undefined,
    15 // rotación ligera
  );

  // Restaurar opacidad
  if (gState) doc.setGState(new doc.GState({ opacity: 1 }));
}




let logoDistribuidoraBottomY = contentBottom + 20;

/* =========================
   LOGO DISTRIBUIDORA FIJO AL PIE
========================= */

if (companyProfile?.logo_url) {
  const logo = await loadImageAsBase64(companyProfile.logo_url);
  const props = doc.getImageProperties(logo);

  const logoWidth = 40;
  const logoHeight = logoWidth * (props.height / props.width);

  const logoX = margin;

  // 🔥 Anclado al fondo con margen seguro
  const footerMargin = 15;
  const logoY = pageHeight - logoHeight - footerMargin;

  doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

  logoDistribuidoraBottomY = logoY + logoHeight;
}


/* =========================
   DATOS EMISOR (COMPACTO)
========================= */

doc.setFontSize(7);
doc.setFont("helvetica", "normal");

const direccionEmpresa = companyProfile?.direccion || {};

const domicilioEmpresa = [
  direccionEmpresa.calle,
  direccionEmpresa.colonia,
  direccionEmpresa.ciudad,
  direccionEmpresa.estado,
  direccionEmpresa.cp
]
  .filter(Boolean)
  .join(", ");

const lineaEmisor = [
  companyProfile?.razon_social,
  `RFC: ${companyProfile?.rfc}`,
  `Tel: ${companyProfile?.telefono}`,
  domicilioEmpresa
]
  .filter(Boolean)
  .join(" · ");

// 🔥 ancho exacto disponible antes de la línea divisoria
const anchoDisponible = (rightColumnX - 8) - margin - 2;

const emisorLines = doc.splitTextToSize(
  lineaEmisor,
  anchoDisponible
);



doc.text(
  emisorLines,
  margin,
  logoDistribuidoraBottomY + 4
);
/* =========================
   CAJA DATOS
========================= */

// 🔥 que la caja empiece alineada con el alcance
const boxY = contentBottom - 8;
let boxTextY = boxY + 10;

/* PRODUCTO ARRIBA */
doc.setFont("helvetica", "bold");
doc.setFontSize(9);

/* =========================
   EQUIPO
========================= */

doc.setFont("helvetica", "bold");
doc.setFontSize(9);
doc.text("Equipo:", rightColumnX + 5, boxTextY);
boxTextY += 5;

doc.setFont("helvetica", "normal");

// 🔥 Construimos con certifiable_products
/* =========================================================
   Nombre del equipo congelado en el certificado.
========================================================= */
const equipoNombre =
  certificate?.equipment_label_snapshot ||
  [
    equipment?.brand,
    equipment?.model,
    equipment?.type
  ]
    .filter(Boolean)
    .join(" ");

const equipoLines = doc.splitTextToSize(
  equipoNombre,
  columnWidth
);

doc.text(equipoLines, rightColumnX + 5, boxTextY);
boxTextY += equipoLines.length * 4 + 6;

/* DATOS */
doc.setFont("helvetica", "bold");
doc.text("Datos de emisión", rightColumnX + 5, boxTextY);
boxTextY += 6;

doc.setFont("helvetica", "normal");

doc.text(
  `No. serie: ${certificate.serial_number}`,
  rightColumnX + 5,
  boxTextY
);
boxTextY += 5;

doc.text(
  `Fecha de emisión: ${formatDate(certificate.issue_date)}`,
  rightColumnX + 5,
  boxTextY
);
boxTextY += 5;

doc.text(
  `Fecha de vigencia: ${formatDate(certificate.valid_until)}`,
  rightColumnX + 5,
  boxTextY
);
boxTextY += 8;


/* =========================
   ESTABLECIMIENTO
========================= */

doc.setFont("helvetica", "bold");
doc.text("Establecimiento:", rightColumnX + 5, boxTextY);
boxTextY += 5;

doc.setFont("helvetica", "normal");

// 🔹 Obtener dirección usando address_key guardado en certificado
let direccionSeleccionada = {};

if (
  client?.direcciones?.envio &&
  certificate?.address_key !== undefined
) {
  direccionSeleccionada =
    client.direcciones.envio[String(certificate.address_key)] || {};
}

// 🔹 RAZÓN SOCIAL (primero)
doc.setFont("helvetica", "bold");
doc.text(client?.razon_social || "N/D", rightColumnX + 5, boxTextY);
boxTextY += 5;

// 🔹 Alias / sucursal (si existe)
doc.setFont("helvetica", "normal");

if (direccionSeleccionada?.alias) {
  doc.text(direccionSeleccionada.alias, rightColumnX + 5, boxTextY);
  boxTextY += 5;
}

// Domicilio completo
const domicilio = [
  direccionSeleccionada?.calle,
  direccionSeleccionada?.colonia,
  direccionSeleccionada?.ciudad,
  direccionSeleccionada?.estado,
  direccionSeleccionada?.cp,
  direccionSeleccionada?.pais
]
  .filter(Boolean)
  .join(", ");

const domicilioLines = doc.splitTextToSize(
  domicilio,
  columnWidth
);

doc.text(domicilioLines, rightColumnX + 5, boxTextY);
boxTextY += domicilioLines.length * 4 + 8;
/* =========================
   CALCULAR ALTURA DINÁMICA
========================= */

const calculatedHeight = Math.max(
  boxTextY - boxY + 35, // espacio contenido + QR
  95
);

doc.roundedRect(
  rightColumnX,
  boxY,
  columnWidth + 10,
  calculatedHeight,
  10,
  10
);

 


/* =========================================================
   DESCARGAR PDF

   En la página pública queremos que el botón descargue
   físicamente el certificado al dispositivo del cliente.
========================================================= */

const safeSerial = String(
  certificate?.serial_number || ""
)
  .replace(/[^a-zA-Z0-9-_]/g, "-");

const fileName =
  `Certificado-${certificate.folio}-${safeSerial}.pdf`;

doc.save(fileName);
}
